import React, { useEffect, useRef, useState } from "react";
import {
  Collapse,
  Descriptions,
  Form,
  Input,
  Button,
  Row,
  Col,
  message,
  Select,
  InputNumber,
  Checkbox,
  Card,
} from "antd";
import utils from "utils";
import api from "utils/api";
import Loader from "Components/Loader";
import icons from "Common/Icons";
import { EditOutlined } from "@ant-design/icons";
import { TextField } from "@mui/material";
import TextArea from "antd/es/input/TextArea";
const { Panel } = Collapse;
const getIndexValueObject = (array) => {
  return array.reduce((obj, item, index) => {
    obj[index] = item.value;
    return obj;
  }, {});
};

const renderFormItemOthers = (item, isEditableField, others_index) => {
  return (
    <Form.Item
      name={["others", others_index]}
      label={item.label}
      // validateTrigger={["onBlur"]}
      //  rules={[{ required: true, message: `Please select ${item.label}` }]}
    >
      <Input
        // style={{ width: "100%" }}
        // placeholder={`Enter ${item.label}`}
        suffix={item.unit}
        disabled={!isEditableField}
        bordered={isEditableField}
        // onChange={(value) => handleFormChange(item.field_value, value)}
        // max={item.max}
        // min={item.min}
      />
    </Form.Item>
  );
};
const renderFormItem = (item, isEditableField) => {
  const disable = !item?.is_changeable;
  switch (item.field_value) {
    case "blood_group":
      return (
        <Form.Item
          name={item.field_value}
          label={item.label}
          // rules={[{ required: true, message: `Please select ${item.label}` }]}
        >
          <Select
            placeholder={`Select ${item.label}`}
            // onChange={(value) =>
            //   handleFormChange(item.field_value, value)
            // }
            disabled={!isEditableField || disable}
            bordered={isEditableField}
          >
            {item.choices.map((choice) => (
              <Select.Option key={choice} value={choice}>
                {choice}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      );
    case "blood_pressure":
      return (
        <Form.Item
          name={item.field_value}
          label={item.label}
          // validateTrigger={["onBlur"]}
          rules={[
            {
              validator: (_, value) => {
                if (!value) {
                  return Promise.resolve();
                }
                if (/^\d+\/\d+$/.test(value)) {
                  const [systolicPressure, diastolicPressure] = value
                    .split("/")
                    .map(Number);
                  const [systolicPressureMin, diastolicPressureMin] = item.min
                    .split("/")
                    .map(Number);
                  const [systolicPressureMax, diastolicPressureMax] = item.max
                    .split("/")
                    .map(Number);

                  if (
                    systolicPressure >= systolicPressureMin &&
                    systolicPressure <= systolicPressureMax &&
                    diastolicPressure >= diastolicPressureMin &&
                    diastolicPressure <= diastolicPressureMax
                  ) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject(
                      `Value must be between ${item.min}${item.unit} and ${item.max}${item.unit}`
                    );
                    return Promise.reject(
                      "Systolic pressure must be between " +
                        systolicPressureMin +
                        " and " +
                        systolicPressureMax +
                        ", and diastolic pressure must be between " +
                        diastolicPressureMin +
                        " and " +
                        diastolicPressureMax
                    );
                  }
                } else {
                  return Promise.reject(`Please enter a valid input`);
                }
              },
            },
          ]}
        >
          <Input
            placeholder={`Enter ${item.label}`}
            suffix={item.unit}
            disabled={!isEditableField || disable}
            bordered={isEditableField}

            // onChange={(e) =>
            //   handleFormChange(item.field_value, e.target.value)
            // }
          />
        </Form.Item>
      );
    default:
      return (
        <Form.Item
          name={item.field_value}
          label={item.label}
          rules={[
            // {
            //   required: true,
            //   message: `Please enter ${item.label}`
            // },
            ({ getFieldValue }) => ({
              validator(_, value) {
                // console.log(value, parseFloat(value));
                if (!value) {
                  return Promise.resolve();
                }
                if (/^\d+(\.\d{1,3})?$/.test(value) && !/\.$/.test(value)) {
                  if (
                    parseFloat(value) >= item.min &&
                    parseFloat(value) <= item.max
                  ) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject(
                      `Value must be between ${item.min}${item.unit} and ${item.max}${item.unit}`
                    );
                  }
                } else {
                  return Promise.reject("Please enter a valid input");
                }
              },
            }),
          ]}
          // validateTrigger={["onBlur"]}
        >
          <Input
            // style={{ width: "100%" }}
            placeholder={`Enter ${item.label}`}
            suffix={item.unit}
            disabled={!isEditableField || disable}
            bordered={isEditableField}
            // onChange={(value) => handleFormChange(item.field_value, value)}
            // max={item.max}
            // min={item.min}
          />
        </Form.Item>
      );
  }
};
const updateAllOthersValues = (data, newValues) => {
  // Make sure newValues array is valid and has the same length as the data array
  if (Array.isArray(newValues) && newValues.length === data.length) {
    // Clone the data array to avoid mutating the original array
    const newData = [...data];

    // Update the value property of each object in the newData array
    newData.forEach((item, index) => {
      newData[index] = {
        ...item,
        value: newValues[index],
      };
    });

    // Return the updated data array
    return newData;
  }

  // If newValues array is not valid or has a different length than the data array, return the original data array
  return data;
};

export const PanelEdit = ({ entry, index, editMode, setEditMode }) => {
  const [form] = Form.useForm();
  const [buttonLoad, setButtonLoader] = useState(false);
  const formreset = useRef({
    ...mapFormDataToValues(entry),
    others: getIndexValueObject(entry?.others),
    comment: entry?.comment,
  });
  function reset() {
    form.setFieldsValue(formreset.current);
  }
  useEffect(() => {
    reset();
  }, []);
  const onFinish = (value) => {
    const { comment, others, ...newValues } = value;
    const newOthers = updateAllOthersValues(entry.others, others);
    const values = { ...newValues, others: newOthers };
    const initialValue = mapFormDataToValues(entry);
    // if (isEmptyCheck(values)) {
    //   message.error("Please Enter values");
    //   return;
    // }
    // if (isObjectSame(values, { ...initialValue, others: entry.others })) {
    //   message.error("Please Change values");
    //   return;
    // }
    const requiredVitals = entry?.required_vitals?.map((item) => ({
      value: values[item.field_value],
      field_value: item.field_value,
    }));
    const payload = {
      vital_id: entry.vital_id,
      required_vitals: requiredVitals,
      others: values.others,
      is_saved: true,
      is_submitted: true,
      comment: comment,
    };

    const apiCall = api.vitals_submit;
    setButtonLoader(true);
    apiCall({ ...payload, patient_id: entry.patient_id })
      .then((response) => {
        if (response.data?.status === 200) {
          // if (key === "primary") {
          //   form.resetFields();
          // }
          formreset.current = {
            ...mapFormDataToValues(values),
            others: getIndexValueObject(values?.others),
            // comment: "",
            comment: comment,
          };
          reset();
          message.success(response.data?.message);
          setEditMode(null);
          //   props.formAction(false);
          //   setIsChecked(false);
          //   fetchInitialVitals();
        } else {
          message.error(response.data?.message);
        }
      })
      .catch((err) => {
        message.error("Something went wrong");
      })
      .finally(() => {
        setButtonLoader(false);
      });
  };
  function isEmptyCheck(values) {
    const isEmpty = Object.values(values).every((value) => {
      if (Array.isArray(value)) {
        return value.length === 0;
      } else {
        return value === "" || value === null;
      }
    });
    return isEmpty;
  }

  function isObjectSame(obj1, obj2) {
    // Check if both objects have the same keys
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    // Check if all properties have the same values
    return keys1.every((key) => {
      const value1 = obj1[key];
      const value2 = obj2[key];

      // If the value is an array, compare each element
      if (Array.isArray(value1) && Array.isArray(value2)) {
        if (value1.length !== value2.length) {
          return false;
        }
        return value1.every((item, index) => {
          return isObjectSame(item, value2[index]);
        });
      }

      // Compare non-array values
      return value1 === value2;
    });
  }
  const isEditableCheck = (index) => {
    return index === editMode;
  };
  const handleCancel = () => {
    setEditMode(null);
    reset();
  };
  return (
    <Card
      style={{ marginTop: 10 }}
      key={index}
      title={
        <div style={{ height: "100%", display:"flex", gap:"2px",fontSize:"14px",fontWeight:"normal",color:"unset"}}>
          {utils.FormatDate(entry.updated_on, "DATE_14")},{" "}
          {utils.FormatDate(entry.updated_on, "TIME_1")}
          <div>
            {!isEditableCheck(index) && entry.is_editable && (
              <EditOutlined
                onClick={() =>
                  setEditMode((prev) => {
                    if (prev != null) {
                      message.warning(
                        "Click on Save or Cancel to proceed further"
                      );
                      return prev;
                    } else {
                      return index;
                    }
                  })
                }
              />
            )}
          </div>
        </div>
      }
      extra={
        <div style={{ height: "100%" }}>
          <div>Updated By: {entry.updated_by}</div>
          <div> Created By : {entry.created_by}</div>
        </div>
      }
      // collapsible="disabled"
      showArrow={false}
    >
      <Form
        form={form}
        wrapperCol={{ span: 12 }}
        labelAlign="left"
        colon={false}
        labelCol={{ span: 10 }}
        onFinish={onFinish}
      >
        <Row gutter={[10, 10]}>
          {entry.required_vitals.filter((vital) => vital.value !== "").length >
            0 &&
            entry?.required_vitals?.map(
              (item) =>
                item.value && (
                  <Col span={8}>
                    {renderFormItem(item, isEditableCheck(index))}
                  </Col>
                )
            )}
          {/* <Divider textAlign="left">others</Divider> */}
          {entry.others.length > 0 &&
            entry?.others?.map(
              (item, others_index) =>
                item.value && (
                  <Col span={8}>
                    {renderFormItemOthers(
                      item,
                      isEditableCheck(index),
                      others_index
                    )}
                  </Col>
                )
            )}
          <Col span={24}>
            {(isEditableCheck(index) ||
              formreset.current.comment.length > 0) && (
              <Form.Item
                wrapperCol={18}
                labelCol={6}
                name="comment"
                label={<span style={{ fontWeight: "bold" }}>Comments</span>}
                rules={[
                  {
                    required: true,
                    message: `Please enter the reason to edit.`,
                  },
                ]}
              >
                <TextArea
                  rows={2}
                  disabled={!isEditableCheck(index)}
                  bordered={isEditableCheck(index)}
                />
              </Form.Item>
            )}
          </Col>
        </Row>
        <div
          className="vitalEditButtonDiv"
          style={{ display: "flex", gap: "7px" }}
        >
          {isEditableCheck(index) && (
            <Button
              className="savebutton"
              htmlType="submit"
              loading={buttonLoad}
            >
              Save
            </Button>
          )}
          {isEditableCheck(index) && (
            <Button
              loading={buttonLoad}
              className="cancelButton"
              style={{
                backgroundColor: "white",
                color: "var(--background-color)",
              }}
              onClick={() => handleCancel()}
            >
              Cancel
            </Button>
          )}
        </div>
      </Form>
    </Card>
  );
};
function mapFormDataToValues(formData) {
  if (!formData) return {};

  const values = {};
  formData?.required_vitals?.forEach((item) => {
    values[item.field_value] = item.value;
  });
  return values;
}
